/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, hasValue, notNull, updateObject } from "../shared/utility";

import Button from "@material-ui/core/Button";
import Card from "../components/UI/Card/Card";
import classes from "./CrimeSubmission.css";
import * as actions from "../store/actions/index";
import Grid from "@material-ui/core/Grid";
import Form from "../components/UI/Form/Form";
import { Image } from "react-bootstrap";
import SectionHeading from "../components/UI/SectionHeading/SectionHeading";

const sectionName = "Attachment";

const mappedSelectPropFields = [];

const mappedTextPropFields = [
  "attachmentTitle",
  "attachmentFileName",
  "attachmentSize",
  "attachmentFileType",
  "previewUrl",
  "id",
  "deleted",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40

class Attachment extends Form {
  state = {
    searching: false,
    editMode: true,
    itemProcessed: false,
    changeTitleRequired: false,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    sectionName: sectionName,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    attachmentTitle: {
      inputType: "text",
      value: "",
      label: "Title / Description",
      validation: { required: false },
    },
    attachmentFileName: {
      inputType: "text",
      value: "",
      label: "FileName",
      validation: { required: false },
      disabled: true,
    },
    attachmentSize: {
      inputType: "text",
      value: "",
      label: "Size in bytes",
      validation: { required: false },
      disabled: true,
    },
    attachmentFileType: {
      inputType: "text",
      value: "",
      label: "File Type",
      validation: { required: false },
      disabled: true,
    },
    previewUrl: {
      inputType: "text",
      value: "",
      label: "url",
      validation: { required: false },
    },
    selectedFile: {
      value: "",
    },
    //
    id: {
      inputType: "text",
      value: "-1",
      label: "ID",
      validation: { required: false },
    },
    deleted: {
      inputType: "text",
      value: "",
      label: "Deleted",
      validation: { required: false },
    },
  };

  addNewAttachmentItem() {
    const newInstance = this.props.attachmentArray.length;
    const attachmentFields = {
      attachmentTitle: "",
      attachmentFileName: "",
      attachmentSize: "",
      attachmentFileType: "",
      selectedFile: null,
      previewUrl: "",
      id: "-1",
      deleted: "",
    };
    const attachmentItem = {
      attachmentInstance: newInstance,
      attachmentFields: attachmentFields,
    };

    if (doLog())
      console.log(
        "[Attachment] addNewAttachmentItem attachmentItem:",
        attachmentItem
      );
    this.props.onAddToAttachmentArray(
      this.props.attachmentArray,
      attachmentItem
    );
  }

  checkAndLoadConfig() {
    if (this.props.configuration != null) {
      if (doLog())
        console.log(
          "[Attachment] ciddbConnectionName:",
          this.props.configuration.ciddbConnectionName
        );
      if (
        this.props.configuration !== null &&
        this.props.configuration.ciddbConnectionName !== null
      ) {
        if (this.props.attachmentSelectFieldList === null) {
          this.props.onSetAttachmentSelectFieldList(mappedSelectPropFields);
        } else if (this.props.attachmentTextFieldList === null) {
          this.props.onSetAttachmentTextFieldList(mappedTextPropFields);
        }
      }
    }
  }

  componentDidMount() {
    if (doLog())
      console.log("[Attachment] componentDidMount state:", this.state);
    if (doLog())
      console.log("[Attachment] componentDidMount props:", this.props);
    this.checkAndLoadConfig();
    this.setFieldRequiredSettings();
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[Attachment] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[Attachment] componentDidUpdate props:", this.props);
    this.checkAndLoadConfig();
    this.copyFieldValuesToState();

    if (
      this.state.selectedFile !== null &&
      this.state.changeTitleRequired &&
      this.state.attachmentTitle.validation.required === true
    ) {
      this.setState({ changeTitleRequired: false });
      this.updateAttachmentArray(
        "attachmentFileName",
        this.state.attachmentFileName.value
      );
    }
  }

  copyFieldValuesToState() {
    if (!this.state.itemProcessed) {
      if (doLog())
        console.log(
          "[Attachment] copyFieldValuesToState item:",
          this.props.item
        );
      if (
        this.props.item !== null &&
        this.props.item.attachmentFields !== null
      ) {
        const attachmentFields = this.props.item.attachmentFields;
        // if (doLog()) console.log("[Attachment] copyFieldValuesToState attachmentFields:", attachmentFields);

        for (let field in this.state.mappedTextPropFields) {
          const fieldName = this.state.mappedTextPropFields[field];
          if (doLog())
            console.log(
              "[Attachment] copyFieldValuesToState text field:",
              fieldName
            );
          // if (doLog()) console.log("[Attachment] copyFieldValuesToState attachmentFields[fieldName]:", attachmentFields[fieldName]);
          if (doLog())
            console.log(
              "[Attachment] copyFieldValuesToState attachmentFields[" +
                fieldName +
                "].value:",
              attachmentFields[fieldName].value
            );
          if (
            hasValue(attachmentFields[fieldName]) &&
            hasValue(attachmentFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: attachmentFields[fieldName].value,
              }),
            });
          }
        }

        for (let field in this.state.mappedSelectPropFields) {
          const fieldName = this.state.mappedSelectPropFields[field];
          if (doLog())
            console.log(
              "[Attachment] copyFieldValuesToState select field:",
              fieldName
            );
          if (
            hasValue(attachmentFields[fieldName]) &&
            hasValue(attachmentFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: attachmentFields[fieldName].value,
              }),
            });
          }
        }
      }
      this.setState({ itemProcessed: true });
    }
  }

  handleAddButton = () => {
    if (doLog()) console.log("handleAddButton");
    this.addNewAttachmentItem();
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[Attachment] handleDeleteButton");
    const attachmentItem = this.props.item;

    if (doLog())
      console.log(
        "[Attachment] handleDeleteButton attachmentItem:",
        attachmentItem
      );
    if (
      hasValue(attachmentItem.attachmentFields.id) &&
      hasValue(attachmentItem.attachmentFields.id.value) &&
      attachmentItem.attachmentFields.id.value !== "-1"
    ) {
      if (doLog())
        console.log("[Attachment] handleDeleteButton setting deleted to Y");
      this.setState({
        deleted: updateObject(this.state.deleted, {
          value: "Y",
        }),
      });
      //update the attachmentArray so that this change doesn't get overridden in copyFieldValuesToState()
      const newAttachmentArray = [];
      const length = this.props.attachmentArray.length;
      for (let i = 0; i < length; i++) {
        let attachmentFields = null;
        const item = this.props.attachmentArray[i];
        if (doLog())
          console.log("[Attachment] handleDeleteButton item[" + i + "]:", item);
        if (item === attachmentItem) item.attachmentFields.deleted.value = "Y";
        attachmentFields = item.attachmentFields;
        console.log(
          "[Attachment] handleDeleteButton attachmentFields:",
          attachmentFields
        );
        newAttachmentArray.push({
          attachmentFields: attachmentFields,
          attachmentInstance: i,
        });
        this.props.onSetAttachmentArray(newAttachmentArray);
      }
    } else {
      if (doLog())
        console.log("[Attachment] handleDeleteButton deleting from array");
      this.props.onDeleteFromAttachmentArray(
        this.props.attachmentArray,
        attachmentItem
      );
    }
  };

  handleFileSelection = (event) => {
    if (doLog()) console.log("[Attachment].handleFileSelection event", event);
    //if (doLog()) console.log("[Attachment].handleFileSelection target", event.target);
    if (doLog())
      console.log("[Attachment].handleFileSelection files", event.target.files);
    event.preventDefault();

    if (event.target.files !== null && event.target.files.length > 0) {
      const fileName = event.target.files[0].name;
      const size = event.target.files[0].size;
      const fileType = event.target.files[0].type;

      let file = event.target.files[0];
      if (file.type.startsWith("image")) {
        let reader = new FileReader();
        reader.onloadend = () => {
          this.setState({
            changeTitleRequired: true,
            // selectedFile: file,
            selectedFile: updateObject(this.state.selectedFile, {
              value: file,
            }),
            attachmentFileName: updateObject(this.state.attachmentFileName, {
              value: fileName,
            }),
            attachmentSize: updateObject(this.state.attachmentSize, {
              value: size,
            }),
            attachmentTitle: updateObject(this.state.attachmentTitle, {
              validation: { required: true },
            }),
            attachmentFileType: updateObject(this.state.attachmentFileType, {
              value: fileType,
            }),
            //selectedPreviewUrl: reader.result,
            previewUrl: updateObject(this.state.previewUrl, {
              value: reader.result,
            }),
            deleted: updateObject(this.state.deleted, {
              value: "",
            }),
          });
          if (doLog())
            console.log("[Attachment] handleFileSelection file:", file);
          const previewURL = reader.result;
          if (doLog())
            console.log(
              "[Attachment] handleFileSelection previewURL:",
              previewURL
            );
        };

        reader.readAsDataURL(file);
      } else {
        this.setState({
          changeTitleRequired: true,
          // selectedFile: file,
          selectedFile: updateObject(this.state.selectedFile, {
            value: file,
          }),
          attachmentFileName: updateObject(this.state.attachmentFileName, {
            value: fileName,
          }),
          attachmentSize: updateObject(this.state.attachmentSize, {
            value: size,
          }),
          attachmentTitle: updateObject(this.state.attachmentTitle, {
            validation: { required: true },
          }),
          attachmentFileType: updateObject(this.state.attachmentFileType, {
            value: fileType,
          }),
          previewUrl: updateObject(this.state.previewUrl, {
            value: null,
          }),
          deleted: updateObject(this.state.deleted, {
            value: "",
          }),
        });
      }
    }
  };

  setFieldRequiredSettings() {
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Attachment]setFieldRequiredSettings text field:", fieldName);
      // if (doLog()) console.log("[Attachment]setFieldRequiredSettings required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }

    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Attachment]setFieldRequiredSettings select field:", fieldName);
      // if (doLog()) console.log("[Attachment]setFieldRequiredSettings select required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }
  }

  render() {
    if (doLog()) console.log("[Attachment] render item:", this.props.item);
    if (doLog())
      console.log(
        "[Attachment] render attachmentInstance:",
        this.props.item.attachmentInstance
      );
    let informationSection = null;
    if (this.props.item.attachmentInstance === 0) {
      informationSection = (
        <Grid item xs={12}>
          <p className={classes.Information}>
            Next, please enter information about the photo(s) and document(s)
            you want to include.
          </p>
          <p>
            Do you have some photos and/or documents that you think would help
            us to better understand the situation?
          </p>
        </Grid>
      );
    }

    let deleteButtonSection = null;
    let selectButtonSection = (
      <Fragment>
        <Button
          variant="contained"
          color="primary"
          component="label"
          size="small"
        >
          Select a file
          <input
            hidden
            accept="image/*,.doc,.docx,.pdf"
            type="file"
            onChange={this.handleFileSelection}
          />
        </Button>
        <p className={classes.EmptyLabel}></p>
      </Fragment>
    );

    if (
      this.state.attachmentFileName.value !== null &&
      this.state.attachmentFileName.value !== ""
    ) {
      deleteButtonSection = (
        <Button
          variant="contained"
          //color="default"
          color="primary"
          size="small"
          onClick={this.handleDeleteButton.bind(this)}
        >
          Cancel
        </Button>
      );
    }

    let previewSection = null;
    let previewUrl = this.state.previewUrl.value;
    if (previewUrl) {
      previewSection = (
        <Image src={previewUrl} thumbnail width="100" height="100" />
      );
    } else {
      previewSection = <div></div>;
    }

    let mainSection = null;
    if (this.state.deleted.value !== "Y") {
      mainSection = (
        <Card>
          <Grid container item className={classes.Card} spacing={gridSpacing}>
            <SectionHeading sectionTitle="Optional Attachments" />
            {informationSection}
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={12}>
              {selectButtonSection}
            </Grid>
            {/* <Grid item xs={9}></Grid> */}
            <Grid item xs={4}>
              {this.getFormField("attachmentTitle", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("attachmentFileName", false, true)}
            </Grid>
            <Grid item xs={2}>
              {this.getFormField("attachmentSize", false, true)}
            </Grid>
            <Grid item xs={4}>
              {previewSection}
            </Grid>
            <Grid item xs={8}></Grid>
            <Grid item xs={6}>
              <Fragment>
                {notNull(this.state.attachmentTitle.value) ? <p /> : null}
                <Button
                  variant="contained"
                  //color="default"
                  color="primary"
                  size="small"
                  onClick={this.handleAddButton.bind(this)}
                >
                  Add another
                </Button>
              </Fragment>
              &nbsp;&nbsp;
              {deleteButtonSection}
            </Grid>
            <Grid item xs={8}></Grid>
          </Grid>
        </Card>
      );
    }

    return (
      // <Card>
      //   <Grid container item className={classes.Card} spacing={gridSpacing}>
      //     <SectionHeading sectionTitle="Optional Attachments" />
      //     {informationSection}
      //     <Grid item xs={12}>
      //       <hr />
      //     </Grid>
      //     <Grid item xs={12}>
      //       {selectButtonSection}
      //     </Grid>
      //     {/* <Grid item xs={9}></Grid> */}
      //     <Grid item xs={4}>
      //       {this.getFormField("attachmentTitle", false, true)}
      //     </Grid>
      //     <Grid item xs={4}>
      //       {this.getFormField("attachmentFileName", false, true)}
      //     </Grid>
      //     <Grid item xs={2}>
      //       {this.getFormField("attachmentSize", false, true)}
      //     </Grid>
      //     <Grid item xs={4}>
      //       {previewSection}
      //     </Grid>
      //     <Grid item xs={8}></Grid>
      //     <Grid item xs={6}>
      //       <Fragment>
      //         {notNull(this.state.attachmentTitle.value) ? <p /> : null}
      //         <Button
      //           variant="contained"
      //           color="default"
      //           size="small"
      //           onClick={this.handleAddButton.bind(this)}
      //         >
      //           Add another
      //         </Button>
      //       </Fragment>
      //       &nbsp;&nbsp;
      //       {deleteButtonSection}
      //     </Grid>
      //     <Grid item xs={8}></Grid>
      //   </Grid>
      // </Card>
      mainSection
    );
  }
}

const mapStateToProps = (state) => {
  // if (doLog()) console.log('Property.mapStateToProps token:', state.auth.token);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    //
    attachmentArray: state.trans.attachmentArray,
    attachmentSelectFieldList: state.trans.attachmentSelectFieldList,
    attachmentTextFieldList: state.trans.attachmentTextFieldList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
    customTextList: state.trans.customTextList,
    requiredFieldList: state.trans.requiredFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddToAttachmentArray: (attachmentArray, attachmentItem) =>
      dispatch(actions.addToAttachmentArray(attachmentArray, attachmentItem)),
    onDeleteFromAttachmentArray: (attachmentArray, attachmentItem) =>
      dispatch(
        actions.deleteFromAttachmentArray(attachmentArray, attachmentItem)
      ),
    onSetAttachmentArray: (attachmentArray) =>
      dispatch(actions.setAttachmentArray(attachmentArray)),
    onSetAttachmentSelectFieldList: (fieldList) =>
      dispatch(actions.setAttachmentSelectFieldList(fieldList)),
    onSetAttachmentTextFieldList: (fieldList) =>
      dispatch(actions.setAttachmentTextFieldList(fieldList)),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Attachment)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Attachment);
